<template>
  <div class="matchListPage">
    <h2 class="orderInfo">
      <span v-if="sendPatientInfo.patient_name">{{sendPatientInfo.patient_name}}</span>
      <span v-if="sendPatientInfo.gender">{{sendPatientInfo.gender === '1'? '男':'女'}}</span>
      <span v-if="sendPatientInfo.patient_phone">{{sendPatientInfo.patient_phone}}</span>
    </h2>
    <Form>
      <Row :gutter="24">
        <Col :span="4">
          <FormItem>
            <DatePicker :getCalendarContainer="(triggerNode) => { return triggerNode.parentNode || document.body }" placeholder="请选择日期" v-model="searchInfo.searchDate"/>
          </FormItem>
        </Col>
        <Col :span="4">
          <FormItem>
            <Select v-model="searchInfo.checkBody" placeholder="请选择检查项目" allowClear>
              <SelectOption v-for="(item, index) in itemList" :key="index" :value="item.id">{{item.name}}</SelectOption>
            </Select>
          </FormItem>
        </Col>
        <Col :span="4">
          <FormItem>
            <Input v-model="searchInfo.patientName" placeholder="请输入患者姓名"></Input>
          </FormItem>
        </Col>
        <Col :span="4">
          <FormItem>
            <Input v-model="searchInfo.patientMobile" placeholder="请输入患者电话"></Input>
          </FormItem>
        </Col>
        <Col :span="4">
          <FormItem>
            <Input v-model="searchInfo.checkBodyItem" placeholder="请输入检查部位"></Input>
          </FormItem>
        </Col>
        <Col :span="4">
          <FormItem>
            <Button type="primary" @click="searchOrder">搜索</Button>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <div class="tableCont">
      <Table size="small" :columns="columns" :dataSource="tableData" border rowKey="id" :pagination="false" :customRow="customRow" :rowClassName="rowClassName"></Table>
    </div>
    <div class="pageWrapper">
      <Pagination v-model="currentPage" :total="totalPage" @change="changePage"></Pagination>
    </div>
    <div slot="footer" class="footer">
      <div>
        <Button size="large" @click="closeOrderMatch">取消</Button>
        <Button size="large" @click="noOrderMate">无匹配项</Button>
        <Button type="primary" size="large" @click="haveOrderMate">匹配</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { Form, Input, Button, Row, Col, Table, Pagination, DatePicker, Select } from 'ant-design-vue' 
import moment from 'moment'
import { switchTimeFormat } from '../../libs/utils'
import { getQuickOrderList, getQuickOrderItem } from '../../api/check'
export default {
  props: {
    sendPatientInfo: {
      type: Object,
      default: () => {}
    },
    matchOrderCode: {
      type: Number,
      default: 0
    }
  },
  components: {
    Form,
    FormItem: Form.Item,
    Input,
    Button,
    Row,
    Col,
    Table,
    Pagination,
    DatePicker,
    Select,
    SelectOption: Select.Option,
  },
  data () {
    return {
      searchInfo: {
        searchDate: moment(switchTimeFormat(new Date().valueOf(), 1)),
        checkBody: undefined,
        patientName: '',
        patientMobile: '',
        checkBodyItem: ''
      },
      columns: [
        { title: '快诊单号', dataIndex: 'order_code' },
        { title: '患者姓名', dataIndex: 'patient_name' },
        { title: '电话', dataIndex: 'patient_phone' },
        { title: '检查项目', dataIndex: 'projectName' },
        { title: '检查部位', dataIndex: 'bodyModeName' },
        { title: '检查备注', dataIndex: 'remark' },
        { title: '预约时间', dataIndex: 'make_at' }
      ],
      tableData: [],
      currentPage: 1,
      pageNo: 1,
      pageSize: 10,
      totalPage: 0,
      orderId: '',
      orderInfo: {},
      itemList: []
    }
  },
  async mounted () {
    await this.getTableData()
    await this.getItemList()
  },
  methods: {
    // 选中某一条标蓝
    customRow (record) {
      return {
        on: {
          click: () => {
            this.orderId = record.order_code
            this.orderInfo = record
          }
        }
      }
    },
    rowClassName (record) {
      return record.order_code === this.orderId ? 'clickRowStyle' : '';
    },
    async getItemList () {
      let data = await getQuickOrderItem({})
      if (data) this.itemList = data
    },
    // 获取列表数据
    async getTableData () {
      let params = {
        pageNumber: this.pageNo,
        pageSize: this.pageSize
      }
      if (this.searchInfo.searchDate) params.createDate = this.searchInfo.searchDate.format('YYYY-MM-DD')
      if (this.searchInfo.patientName) params.patientName = this.searchInfo.patientName
      if (this.searchInfo.patientMobile) params.patienMobile = this.searchInfo.patientMobile
      if (this.searchInfo.checkBody) params.project_id = this.searchInfo.checkBody
      if (this.searchInfo.checkBodyItem) params.bodyModeName = this.searchInfo.checkBodyItem
      let data = await getQuickOrderList(params)
      if (data) {
        this.tableData = data.results
        this.totalPage = data.totalCount
      }
      this.handleChangedData()
    },
    handleChangedData () {
      for (let i = 0; i < this.tableData.length; i++) {
        let item = this.tableData[i]
        if (this.matchOrderCode && this.matchOrderCode.toString() === item.order_code) {
          this.orderId = this.matchOrderCode.toString()
          this.orderInfo = this.tableData[i]
          break
        } else {
          this.orderId = this.tableData[0].order_code
          this.orderInfo = this.tableData[0]
        }
      }
    },
    // 分页
    async changePage (page) {
      this.pageNo = page
      await this.getTableData()
    },
    // 搜索按钮
    async searchOrder () {
      this.pageNo = 1
      this.currentPage = 1
      await this.getTableData()
    },
    // 无匹配
    noOrderMate () {
      this.$emit('noOrderMate')
    },
    // 匹配到订单
    haveOrderMate () {
      this.$emit('haveOrderMate', this.orderInfo)
    },
    closeOrderMatch () {
      this.$emit('closeOrderMatch')
    }
  }
}
</script>

<style lang="less">
@import url('../../style/index.less');
.matchListPage{
  .orderInfo{
    margin-bottom:20px;
    background:#f2f2f2;
    font-size: @bigFontSize;
    span{
      margin-right: 10px;
    }
  }
  .tableCont{
    height: 240px;
    overflow-y: auto;
  }
  .clickRowStyle{
    background: @primaryColor;
  }
  .ant-table-tbody>.clickRowStyle:hover>td {
    background: @primaryColor;
  }
  .pageWrapper{
    margin-top:20px;
  }
  .footer{
    .modalFooter();
  }
  .ant-row .ant-form-item{
    display: flex;
    .ant-form-item-control-wrapper{
      width: 100%;
    }
  }
}
</style>